import React from "react";
import { Col, Row, theme } from "antd";

import logo from "../../../../resource/images/logo.svg";
import styles from "./index.module.scss";

export interface WrapperProps {
  children: React.ReactNode;
}

export default function Wrapper({ children }: WrapperProps): React.ReactNode {
  const {
    token: { colorBgContainer, boxShadowTertiary },
  } = theme.useToken();

  return (
    <Row justify="center">
      <Col className={styles.wrapper}>
        <div className={styles.logo}>
          <img src={logo} alt="Triare" />
        </div>

        {/* boxShadowTertiary, not the Secondary this card used to carry: the
            lightest of antd's three, enough to lift the card off the tinted
            page without reading as a floating panel. */}
        <div
          className={styles.content}
          style={{
            backgroundColor: colorBgContainer,
            boxShadow: boxShadowTertiary,
          }}
        >
          {children}
        </div>
      </Col>
    </Row>
  );
}
